<template>
	<div>
		<a-modal
			:bodyStyle="{ padding: 0 }"
			:mask="true"
			width="80%"
			wrapClassName="attachClass"
			:dialogStyle="{}"
			dialogClass="dialogClass"
			:maskStyle="{}"
			:title="
				(h) => {
					return h('div', [h('span', '下载 / 查看报关资料')]);
				}
			"
			:visible="visibleAttach"
			@cancel="closeAttach"
		>
			<template>
				<div :style="{ height: '100%' }">
					<div :style="{ height: '94%' }">
						<template
							v-if="
								attach[current - 1] &&
									attach[current - 1].type.search(/^(jp|png)/i) != -1
							"
						>
							<div class="attactment-wrap">
								<img
									@mousedown="imgMove"
									:src="attach[current - 1].url"
									alt=""
									class="imgStyle"
									:style="imgStyle"
									ref="imageBox"
								/>
							</div>
						</template>
						<template v-else-if="attach[current - 1]">
							<iframe
								:src="previewFile(attach[current - 1].url)"
								:style="{ height: '100%', width: '100%' }"
								frameborder="0"
							></iframe>
						</template>
					</div>
					<div class="attachment-footer">
						<!--left-->
						<div class="opt-left">
							<!-- <a
								class=""
								@click="
									downloadFile(
										attach[current - 1] ? attach[current - 1].attachmentId : '',
										attach[current - 1]
											? attach[current - 1].attachmentId +
													'.' +
													attach[current - 1].name.split('.')[1]
											: '',
										''
									)
								"
							>
								<a-icon
									type="download"
									:style="{
										cursor: 'pointer',
										fontSize: '20px',
										color: 'red',
									}"
									title="下载"
								/>
							</a> -->
							<a
								class=""
								@click="
									downloadFile(
										'',
										'报关资料' + attach[current - 1].blNumber + '附件.zip',
										declarationId
									)
								"
							>
								<a-icon
									type="download"
									:style="{
										cursor: 'pointer',
										fontSize: '20px',
										color: 'blue',
										borderBottom: '1px solid',
									}"
									title="批量下载"
								/>
							</a>
						</div>
						<!--middle-->
						<div class="opt-middle">
							<span>
								附件名称:
								{{
									attach[current - 1] ? attach[current - 1].name : "无信息"
								}}</span
							>
						</div>

						<div class="change-img-size">
							<a
								style="marginRight:15px;"
								class=""
								@click="
									downloadFile(
										attach[current - 1] ? attach[current - 1].attachmentId : '',
										attach[current - 1]
											? attach[current - 1].attachmentId +
													'.' +
													attach[current - 1].name.split('.')[1]
											: '',
										''
									)
								"
							>
								<a-icon
									type="download"
									:style="{
										cursor: 'pointer',
										fontSize: '20px',
										color: 'red',
									}"
									title="下载"
								/>
							</a>
							<a-button size="small" @click="toBIgChange">
								<a-icon type="zoom-in" />
							</a-button>
							<a-button size="small" @click="toSmallChange">
								<a-icon type="zoom-out" />
							</a-button>
							<a-button size="small" @click="rotateLeft()"
								><a-icon type="redo"
							/></a-button>
						</div>
						<!--right-->
						<div class="opt-right">
							<a-row type="flex" justify="space-around" align="middle">
								<a-col
									:span="4"
									title="上一页"
									class="optPage left"
									onselectstart="return false"
								>
									<a-icon
										type="left"
										:class="current == 1 ? 'notAllow' : 'allow'"
										@click="preImg"
									/>
								</a-col>
								<a-col :span="16">
									<a-input
										size="small"
										class="jup"
										:title="current + '/' + attach.length"
										v-model.number="currentValue"
										@blur="onBlur"
										@keyup.enter.native="keyup"
									></a-input>
									<span style="margin: 0 8px;">/</span>
									<span>{{ attach.length }}</span>
								</a-col>
								<a-col
									:span="4"
									title="下一页"
									class="optPage right"
									onselectstart="return false"
								>
									<a-icon
										type="right"
										:class="current == attach.length ? 'notAllow' : 'allow'"
										@click="nextImg"
									/>
								</a-col>
							</a-row>
						</div>
					</div>
				</div>
			</template>

			<template slot="footer" class="footer">
				<a-button key="back" @click="closeAttach">
					关闭
				</a-button>
			</template>
		</a-modal>
	</div>
</template>

<script>
import {
	queryDeclarationAttachment,
	downloadCustomsDeclaration,
} from "../../api/business-dispatch";
import { searchReqParam } from "../../utils/searchReqParam";

export default {
	name: "file-download",
	props: {
		selectedRows: {
			type: Array,
			default() {
				return [];
			},
		},
	},
	components: {},
	data() {
		return {
			req: searchReqParam(),
			visibleAttach: false,
			attach: [],
			current: 1,
			currentValue: 1,
			rotateTimes: 0,
			multiples: 1,
			imgStyle: "",
			declarationId: "",
			blNumber: "",
		};
	},
	computed: {},
	mounted() {},
	methods: {
		// 关闭附件预览弹框
		closeAttach() {
			this.visibleAttach = false;
			this.current = 1;
			this.currentValue = 1;
			this.attach = [];
			this.imgStyle = "";
		},
		// 查看附件
		showAttachment(scope) {
			// let params = scope.attach.containerId;
			console.log(scope);
			let params = {
				attachmentType: "CUSTOMS_DECLARATION",
				declarationId: "",
			};
			// 此处containerId 须使用报关 id
			params.declarationId = scope.attach.containerId;
			this.req.params = params;
			// containerId
			this.declarationId = scope.attach.containerId;
			this.blNumber = scope.attach.blNumber;

			queryDeclarationAttachment(this.req).then((res) => {
				this.attach = [];
				let resData = JSON.parse(res.data).data;
				console.log(resData);
				if (resData.length == 0) {
					this.$message.warn("暂无附件信息");
					return;
				}
				this.attach = this.getAttachments(resData);
				this.visibleAttach = true;
			});
		},
		// 对附件进行封装
		getAttachments(queryDeclarationAttachment) {
			let attachments = [];
			queryDeclarationAttachment.forEach((element, index) => {
				console.log(
					element.url.substr(element.url.lastIndexOf("."), element.url.length)
				);
				let fileType = element.url.substr(
					element.url.lastIndexOf(".") + 1,
					element.url.length
				);
				let name = element.url.substr(
					element.url.lastIndexOf("/") + 1,
					element.url.length
				);
				attachments.push({
					id: index,
					type: fileType,
					fileType: element.fileType,
					url: element.url,
					name: name,
					attachmentId: element.attachmentId,
					blNumber: this.blNumber,
				});
			});
			//  对附件排序
			// attachments.sort((a, b) => {
			// 	return a.type > b.type ? 1 : -1;
			// });
			return attachments;
		},
		//  下载
		downloadFile(attachmentId, name, declarationId) {
			console.log(attachmentId, name, declarationId);
			console.log(this.req);
			let reqParams = {
				meta: this.req.meta,
				params: {
					attachmentId: attachmentId,
					declarationId: declarationId,
				},
			};
			downloadCustomsDeclaration(reqParams).then((res) => {
				console.log(res.data);
				let blob = res.data;

				let reader = new FileReader();

				reader.readAsDataURL(blob);
				console.log("reader ==== ", reader);

				reader.onload = (e) => {
					let a = document.createElement("a");

					a.download = name;

					a.href = e.target.result;

					document.body.appendChild(a);

					a.click();

					document.body.removeChild(a);
				};
			});
		},
		//base64转blob
		base64ToBlob(code) {
			let parts = code.split(";base64,");
			let contentType = parts[0].split(":")[1];
			let raw = window.atob(parts[1]);
			let rawLength = raw.length;

			let uInt8Array = new Uint8Array(rawLength);

			for (let i = 0; i < rawLength; ++i) {
				uInt8Array[i] = raw.charCodeAt(i);
			}
			return new Blob([uInt8Array], { type: contentType });
		},
		// 快速到达指定页
		onBlur() {
			console.log("this.currentValue", this.currentValue);
			if (this.currentValue == "") {
				this.currentValue = this.current;
				return;
			}
			this.current = this.currentValue;
		},
		keyup(e) {
			console.log(this.currentValue);
			e.target.blur();
		},
		//  查看上一个附件
		preImg() {
			if (this.current > 1) {
				window.getSelection
					? window.getSelection().removeAllRanges()
					: document.selection.empty();
				this.current--;
				this.currentValue = this.current;
			}
		},
		// 查看下一个附件
		nextImg() {
			if (this.current < this.attach.length) {
				this.current++;
				this.currentValue = this.current;
			}
		},
		// 在线查看文件
		previewFile(url) {
			let pdfUrl = url;
			var i = null;
			var ssl = null;
			var a = pdfUrl.substr(0, 5);
			if (a == "https") {
				i = "21627";
				ssl = "&ssl=1";
			} else {
				pdfUrl = pdfUrl.replace("http", "https");
				i = "21627";
				ssl = "&ssl=1";
			}
			if (pdfUrl.indexOf("yzs-overt.oss-cn-shanghai.aliyuncs.com") != -1) {
				i = "34260";
			}
			if (pdfUrl.indexOf("driverglobe.com") != -1) {
				i = "34260";
			}
			if (pdfUrl.indexOf("tximage.fat.driverglobe.com") != -1) {
				i = "34947";
			}
			return "http://vip.ow365.cn/?i=" + i + ssl + "&furl=" + pdfUrl;
			// window.open("http://vip.ow365.cn/?i=" + i + ssl + "&furl=" + pdfUrl);
		},
		// 旋转图片
		rotateLeft() {
			this.rotateTimes++;
			this.imgStyle = `transform: rotate(${90 * this.rotateTimes}deg) scale(${
				this.multiples
			})`;
			console.log(this.imgStyle);
		},
		// 放大
		toBIgChange() {
			if (this.multiples >= 2) {
				return;
			}
			this.multiples += 0.25;
			this.imgStyle = `transform: rotate(${90 * this.rotateTimes}deg) scale(${
				this.multiples
			})`;
		},
		// 缩小
		toSmallChange() {
			if (this.multiples <= 1) {
				return;
			}
			this.multiples -= 0.25;
			this.imgStyle = `transform: rotate(${90 * this.rotateTimes}deg) scale(${
				this.multiples
			})`; //
		},
		// 实现图片拖拽
		imgMove(e) {
			this.cleanUpDefaultEvent(e);
			console.log("e", e.clientX, e.target.offsetLeft);
			let oImg = e.target;
			let disX = e.clientX - oImg.offsetLeft;
			let disY = e.clientY - oImg.offsetTop;
			document.onmousemove = (e) => {
				e.preventDefault();
				let left = e.clientX - disX;
				let top = e.clientY - disY;
				this.imgStyle = this.imgStyle + `left: ${left}px; top:${top}px;`;
			};
			document.onmouseup = () => {
				document.onmousemove = null;
				document.onmousemove = null;
			};
		},
	},
};
</script>

<style lang="less" scoped>
.optPage {
	background: white;
	border-radius: 3px;
}
/deep/ .jup {
	width: 30px;
	display: inline-block;
	padding: 0;
	text-align: center;
}
/deep/ .notAllow {
	cursor: not-allowed;
	opacity: 0.5;
}
/deep/ .allow {
	&:hover {
		cursor: pointer;
		color: #1890ff;
	}
}
.eyeIcon {
	opacity: 0;
}
.download {
	margin-left: 15px;
}

/deep/ .dialogClass {
	height: 80% !important;
	width: 60% !important;
}
// 弹窗内容
/deep/ .ant-modal-content {
	height: 100%;
	width: 100%;
	.ant-modal-close {
		height: 6%;
		width: 50px;
		display: flex;
		justify-content: center;
		align-items: center;
		.ant-modal-close-x {
			width: 100%;
			height: 100%;
			display: flex;
			justify-content: center;
			align-items: center;
		}
	}
	.ant-modal-header {
		height: 6%;
		padding: 0;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.ant-modal-body {
		height: 88%;
		overflow: hidden;
		.ant-pagination-simple .ant-pagination-simple-pager input:nth-child(1) {
			width: 40px;
		}
	}
	.ant-modal-footer {
		height: 6%;
		padding: 0;
		display: flex;
		justify-content: center;
		align-items: center;
		.ant-btn {
			font-size: 12px;
		}
	}
	.imgStyle {
		width: auto;
		height: auto;
		max-width: 100%;
		max-height: 100%;
		position: absolute;
		cursor: pointer;
	}
}

.attactment-wrap {
	width: 100%;
	height: 100%;
	position: relative;
	display: flex;
	justify-content: center;
}
@media screen and (max-width: 768px) {
	/deep/ .ant-modal-content {
		width: 1040px;
	}
}
.attachment-footer {
	height: 6%;
	position: relative;
	display: flex;
	align-items: center;
	background: #c7c5c5;
	font-weight: bold;
}
.change-img-size {
	position: absolute;
	right: 186px;
}
.opt-left {
	width: 4%;
}
.opt-middle {
	width: 46%;
	text-align: left;
}
.opt-right {
	position: absolute;
	right: 10px;
	width: 150px;
}
</style>
